import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import Carousel, { Modal, ModalGateway } from 'react-images'

import GlobalContext from 'agency/digital_renderer/utils/context'

const mapImages = (gallerySource, campaignImages, galleryItems) => {
  if (gallerySource === 'custom' && galleryItems){
    return galleryItems.map(item => ({ src: item.value }))
  }

  return campaignImages.map(image => ({ src: image.large_url }))
}

const Gallery = (props) => {
  const { options } = props
  const { galleryItems, galleryKey, gallerySource } = options || {}

  const defaultContext = useContext(GlobalContext)
  const { callbacks: { toggleGallery }, campaignImages, toggleableComponents } = defaultContext

  const modalIsOpen = toggleableComponents[galleryKey] || false
  const currentIndex = toggleableComponents[`${galleryKey}SelectedIndex`] || 0

  const images = mapImages(gallerySource, campaignImages, galleryItems)

  if (!images || !images.length){
    return null
  }

  return (
    <ModalGateway>
      {modalIsOpen ? (
        <Modal
          onClose={() => toggleGallery(galleryKey, 0)}
          styles={{ blanket: base => ({ ...base, zIndex: 10 }), positioner: base => ({ ...base, zIndex: 11 }) }}
        >
          <Carousel currentIndex={currentIndex} views={images} />
        </Modal>
      ) : null}
    </ModalGateway>
  )
}

Gallery.propTypes = {
  options: PropTypes.object,
}

Gallery.defaultProps = {
  options: {},
}

export default Gallery
